
export const scheduleData = [
  {
    id: 1,
    date: '2025-07-05',
    day: '土',
    time: '18:30',
    doorOpen: '18:00',
    venue: '下北沢 SOUND DOOR',
    artist: 'THE URBAN LIGHTS',
    title: 'Summer Rock Explosion',
    genre: 'ロック',
    price: 3500,
    ticketUrl: 'https://example-eplus.jp/event/001',
    status: 'on-sale',
    description: '夏の夜を熱くするロックライブ。新曲初披露あり。'
  },
  {
    id: 2,
    date: '2025-07-06',
    day: '日',
    time: '19:00',
    doorOpen: '18:30',
    venue: '吉祥寺 MOONLIGHT',
    artist: '藤原 美月',
    title: 'Moonlit Jazz Session',
    genre: 'ジャズ',
    price: 4000,
    ticketUrl: 'https://example-eplus.jp/event/002',
    status: 'on-sale',
    description: 'ピアノとボーカルが織りなす極上のジャズナイト。'
  },
  {
    id: 3,
    date: '2025-07-11',
    day: '金',
    time: '19:30',
    doorOpen: '19:00',
    venue: '恵比寿 BRICK',
    artist: 'Neon Pulse',
    title: 'Electric Night Vol.12',
    genre: 'エレクトロニカ',
    price: 3800,
    ticketUrl: 'https://example-eplus.jp/event/003',
    status: 'on-sale',
    description: 'シンセサウンドとビジュアル演出の融合ライブ。'
  },
  {
    id: 4,
    date: '2025-07-12',
    day: '土',
    time: '18:00',
    doorOpen: '17:30',
    venue: '渋谷 LIGHTHOUSE',
    artist: '木村 蓮 & The Drifters',
    title: 'Acoustic Sunset',
    genre: 'アコースティック',
    price: 3000,
    ticketUrl: 'https://example-eplus.jp/event/004',
    status: 'on-sale',
    description: '心に響くアコースティックサウンドの夕べ。'
  },
  {
    id: 5,
    date: '2025-07-13',
    day: '日',
    time: '17:00',
    doorOpen: '16:30',
    venue: '六本木 BEAT HALL',
    artist: 'SOUL KITCHEN',
    title: 'Sunday Soul Brunch Live',
    genre: 'R&B/ソウル',
    price: 4200,
    ticketUrl: 'https://example-eplus.jp/event/005',
    status: 'on-sale',
    description: '日曜の午後をソウルフルに彩るスペシャルライブ。'
  },
  {
    id: 6,
    date: '2025-07-18',
    day: '金',
    time: '19:00',
    doorOpen: '18:30',
    venue: '下北沢 SOUND DOOR',
    artist: '高橋 翔太',
    title: 'Singer-Songwriter Night',
    genre: 'シンガーソングライター',
    price: 3200,
    ticketUrl: 'https://example-eplus.jp/event/006',
    status: 'on-sale',
    description: '注目の若手シンガーソングライターによる弾き語りライブ。'
  },
  {
    id: 7,
    date: '2025-07-19',
    day: '土',
    time: '18:30',
    doorOpen: '18:00',
    venue: '吉祥寺 MOONLIGHT',
    artist: 'Midnight Express',
    title: 'Blues & Bourbon',
    genre: 'ブルース',
    price: 3800,
    ticketUrl: 'https://example-eplus.jp/event/007',
    status: 'on-sale',
    description: '本格ブルースギターとウイスキーの夜。'
  },
  {
    id: 8,
    date: '2025-07-20',
    day: '日',
    time: '16:00',
    doorOpen: '15:30',
    venue: '恵比寿 BRICK',
    artist: 'THE URBAN LIGHTS / Neon Pulse / 高橋 翔太',
    title: '3マンライブ SUMMER CLASH',
    genre: 'ロック',
    price: 4500,
    ticketUrl: 'https://example-eplus.jp/event/008',
    status: 'on-sale',
    description: '3組のアーティストが競演する夏の特別イベント。'
  },
  {
    id: 9,
    date: '2025-07-25',
    day: '金',
    time: '19:30',
    doorOpen: '19:00',
    venue: '渋谷 LIGHTHOUSE',
    artist: '藤原 美月',
    title: 'Piano Ballad Night',
    genre: 'ジャズ',
    price: 4000,
    ticketUrl: 'https://example-eplus.jp/event/009',
    status: 'on-sale',
    description: 'ピアノバラードの名曲を中心にした特別公演。'
  },
  {
    id: 10,
    date: '2025-07-26',
    day: '土',
    time: '18:00',
    doorOpen: '17:30',
    venue: '六本木 BEAT HALL',
    artist: 'DJ KAZE & MC FLOW',
    title: 'Hip Hop Summer Jam',
    genre: 'ヒップホップ',
    price: 3500,
    ticketUrl: 'https://example-eplus.jp/event/010',
    status: 'on-sale',
    description: '東京ヒップホップシーンの最前線を体感せよ。'
  },
  {
    id: 11,
    date: '2025-07-27',
    day: '日',
    time: '17:00',
    doorOpen: '16:30',
    venue: '下北沢 SOUND DOOR',
    artist: '木村 蓮 & The Drifters',
    title: 'Folk & Country Afternoon',
    genre: 'フォーク',
    price: 3000,
    ticketUrl: 'https://example-eplus.jp/event/011',
    status: 'on-sale',
    description: '日曜の午後にぴったりのフォーク＆カントリーライブ。'
  },
  {
    id: 12,
    date: '2025-08-01',
    day: '金',
    time: '19:00',
    doorOpen: '18:30',
    venue: '恵比寿 BRICK',
    artist: 'SOUL KITCHEN',
    title: 'August Soul Opener',
    genre: 'R&B/ソウル',
    price: 4000,
    ticketUrl: 'https://example-eplus.jp/event/012',
    status: 'on-sale',
    description: '8月の幕開けを飾るソウルフルなステージ。'
  },
  {
    id: 13,
    date: '2025-08-02',
    day: '土',
    time: '18:30',
    doorOpen: '18:00',
    venue: '渋谷 LIGHTHOUSE',
    artist: 'THE URBAN LIGHTS',
    title: 'Midsummer Rock Fest',
    genre: 'ロック',
    price: 3800,
    ticketUrl: 'https://example-eplus.jp/event/013',
    status: 'on-sale',
    description: '真夏のロックフェスティバル。ゲストバンドあり。'
  },
  {
    id: 14,
    date: '2025-08-08',
    day: '金',
    time: '19:30',
    doorOpen: '19:00',
    venue: '六本木 BEAT HALL',
    artist: 'Midnight Express',
    title: 'Late Night Blues',
    genre: 'ブルース',
    price: 3800,
    ticketUrl: 'https://example-eplus.jp/event/014',
    status: 'on-sale',
    description: '深夜のブルースセッション。飛び入り参加歓迎。'
  },
  {
    id: 15,
    date: '2025-08-09',
    day: '土',
    time: '17:00',
    doorOpen: '16:30',
    venue: '吉祥寺 MOONLIGHT',
    artist: '高橋 翔太 / 藤原 美月',
    title: 'Duo Acoustic Live',
    genre: 'アコースティック',
    price: 3500,
    ticketUrl: 'https://example-eplus.jp/event/015',
    status: 'on-sale',
    description: '2人のシンガーソングライターによるスペシャルコラボ。'
  },
  {
    id: 16,
    date: '2025-08-15',
    day: '金',
    time: '18:00',
    doorOpen: '17:30',
    venue: '下北沢 SOUND DOOR',
    artist: 'Neon Pulse',
    title: 'Obon Electronic Night',
    genre: 'エレクトロニカ',
    price: 3500,
    ticketUrl: 'https://example-eplus.jp/event/016',
    status: 'on-sale',
    description: 'お盆特別企画。光と音の幻想的なライブ体験。'
  },
  {
    id: 17,
    date: '2025-08-16',
    day: '土',
    time: '18:30',
    doorOpen: '18:00',
    venue: '恵比寿 BRICK',
    artist: 'DJ KAZE & MC FLOW',
    title: 'Summer Hip Hop Bash',
    genre: 'ヒップホップ',
    price: 3800,
    ticketUrl: 'https://example-eplus.jp/event/017',
    status: 'on-sale',
    description: '夏のヒップホップパーティー。フリースタイルバトルあり。'
  },
  {
    id: 18,
    date: '2025-08-22',
    day: '金',
    time: '19:00',
    doorOpen: '18:30',
    venue: '渋谷 LIGHTHOUSE',
    artist: '木村 蓮 & The Drifters',
    title: 'End of Summer Acoustic',
    genre: 'アコースティック',
    price: 3200,
    ticketUrl: 'https://example-eplus.jp/event/018',
    status: 'on-sale',
    description: '夏の終わりを感じるアコースティックライブ。'
  },
  {
    id: 19,
    date: '2025-08-23',
    day: '土',
    time: '18:00',
    doorOpen: '17:30',
    venue: '六本木 BEAT HALL',
    artist: 'SOUL KITCHEN / Midnight Express / 藤原 美月',
    title: 'BEAT HALL 5th Anniversary',
    genre: 'R&B/ソウル',
    price: 5000,
    ticketUrl: 'https://example-eplus.jp/event/019',
    status: 'on-sale',
    description: 'BEAT HALL開業5周年記念の豪華3マンライブ。'
  },
  {
    id: 20,
    date: '2025-08-30',
    day: '土',
    time: '16:00',
    doorOpen: '15:30',
    venue: '恵比寿 BRICK',
    artist: 'THE URBAN LIGHTS / Neon Pulse / SOUL KITCHEN / DJ KAZE',
    title: 'SUMMER FINAL FESTIVAL',
    genre: 'ロック',
    price: 5500,
    ticketUrl: 'https://example-eplus.jp/event/020',
    status: 'on-sale',
    description: '夏の締めくくり。4組が集結する大型フェスティバル。'
  }
];

export const genreList = [
  'すべて',
  'ロック',
  'ジャズ',
  'エレクトロニカ',
  'アコースティック',
  'R&B/ソウル',
  'シンガーソングライター',
  'ブルース',
  'ヒップホップ',
  'フォーク'
];

export const venueFilterList = [
  'すべて',
  '下北沢 SOUND DOOR',
  '吉祥寺 MOONLIGHT',
  '恵比寿 BRICK',
  '渋谷 LIGHTHOUSE',
  '六本木 BEAT HALL'
];
